import gql from 'graphql-tag'

export const CREATE_PRESET_CATEGORY = gql`
  mutation CreatePresetCategory($name: String!) {
    createPresetCategory(data: { name: $name }) {
      id
      name
    }
  }
`

export const UPDATE_PRESET_CATEGORY = gql`
  mutation UpdatePresetCategory($id: Int!, $name: String!) {
    updatePresetCategory(id: $id, data: { name: $name }) {
      id
      name
    }
  }
`

export const DELETE_PRESET_CATEGORY = gql`
  mutation DeletePresetCategory($id: Int!) {
    deletePresetCategory(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/PresetCategory.js